import React from "react";

function HomeHistorys({
    title = 'Historias MEDATA',
    text = 'Conoce las historias y casos de éxito de los usuarios del portal de datos abiertos del municipio de Medellín',
    url = '/historias' }) {


    return (
        <>
            <p className="title title--blue">
                {title}
            </p>
            <hr className="separator separator--blue" />
            <p className="text">
                {text}
            </p>
            <div className="mt-5 text-center">
                <a className="button button-primary" title="Historias" href={url}>
                    CONOCE MÁS
                </a>
            </div>
        </>

    )
}

export default HomeHistorys